<template>
  <section>
    <AdminHeader
      v-bind:headerName="$t('newUi.sideBarData.formsTitle')"
      view_form=""
    />
    <v-overlay :value="set_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div style="display:flex;justify-content: flex-end;">
      <selectLocale
        style="color: #94b978;margin-top:15px; margin-right: 15px; "
      />
    </div>
    <orderManagementComponent> </orderManagementComponent>
  </section>
</template>

<script>
// @ is an alias to /src
// import GsItemCard from "@/components/GsItemCard.vue";
import orderManagementComponent from "@/components/orderManagementComponent.vue";
import AdminHeader from "@/layout/adminHeader.vue";
import router from "../router/router";
import { mapGetters } from "vuex";
import selectLocale from "../components/selectLocale";
import store from "../store/store";
import { saveFile, setLocale, loadMaster } from "../services/firebase";
import i18n from "../i18n";
export default {
  data() {
    return {
      name: "",
      showMessage: false,
      locale: "Deutsch",
      set_overlay: false,
    };
  },
  props: ["forms", "headerName"],
  components: {
    // GsItemCard,
    AdminHeader,
    selectLocale,
    orderManagementComponent,
  },
  methods: {
    fetchData(state) {
      if (state.profile.isSigned) {
        var elethis = this;
        elethis.set_overlay = true;
        loadMaster(state.profile.uid, function() {
          store.dispatch("setOverlay", false);
          elethis.set_overlay = false;
        });
      } else {
        router.push("/");
      }
    },
    createForm() {
      var createPos = this.getFreePos();
      if (createPos === -1) {
        alert(i18n.t("alertText.fiveForms"));
        return;
      }
      console.log(createPos);
      //this.selectType(createPos);
      this.selectType(function(type) {
        console.log("Creating form, type:" + type);
        var newlink = "/admin/editform/" + createPos;
        console.log("newlink", newlink);
        var newForm = {
          id: store.state.profile.uid,
          pos: createPos,
          categs: ["Ordering form", "Catalogue"],
          shopname: "",
          shopdesc: "",
          type: type,
          catalogue: [],
          phone: "+91",
          amount: 0,
          maxlength: 0,
        };

        saveFile(
          store.state.profile.uid,
          createPos,
          JSON.stringify(newForm),
          function() {
            //state.forms.push({"shopname": "", "type": + type, "link":"/admin/" + createPos});
            if (router.currentRoute.fullPath != newlink) {
              router.push("/admin/editform/" + createPos);
            }
          }
        );
      });
    },
    getFreePos() {
      var isPresent = [];
      for (var ii = 0; ii < 5; ii++) isPresent[ii] = false;
      for (var i = 0; i < this.$store.state.forms.length; i++) {
        var formlink = this.$store.state.forms[i].link;
        //var ipos = parseInt(formlink.split("/")[3]);
        var ipos;
        if (formlink.split("/")[3]) {
          ipos = parseInt(formlink.split("/")[3]);
        } else {
          ipos = parseInt(formlink.split("/")[2]);
        }
        if (ipos >= 0 && ipos < 5) isPresent[ipos] = true;
      }
      for (var j = 0; j < 5; j++) if (!isPresent[j]) return j;
      return -1;
    },
    selectType(callback) {
      console.log(this.$store.state);
      this.$store.dispatch("setCurCallback", callback);
      console.log(this.$store.state.curcallback);
      //router.push("/newform");
      this.$store.state.newformroute.newformdialog = true;
      console.log("2");
      store.dispatch("setOverlay", false);
    },
  },

  mounted() {
    var state = this.$store.state;
    setLocale();
    this.fetchData(state);
  },
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
    search() {
      return this.$store.state.search;
    },
    isNotification() {
      return this.$store.state.isNotificationMsg;
    },
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData",
  },
};
</script>
